
import React from 'react';
import classes from './CustomDataBox.module.scss';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import CustomEvents from 'Flow2/components/CustomCollections/CustomDataConfig/CustomAppEvents';
import { CustomAppEventListener, isFrancetv, isNLW, isPorscheArchiv } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController.js';
import * as DataUtil from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';
import * as CustomMedia from 'Flow2/components/CustomCollections/CustomDataControllers/CustomMediaController';
import * as CustomForm from 'Flow2/components/CustomCollections/CustomDataControllers/CustomFormController';
import CustomFadeBox from 'Flow2/components/CustomCollections/CustomBox/CustomFadeBox/CustomFadeBox';
import CustomDragDropBox from "Flow2/components/CustomCollections/CustomBox/CustomDragDropBox/CustomDragDropBox";
import * as fTypes from "Flow2/components/Share/FlexUpload/FlexUploadConfig/FlexUploadTypes";
import Dropdown from "Flow2/components/AdvancedBox/AdvancedUI/Dropdown/Dropdown";
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faObjectGroup } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker, { registerLocale } from "react-datepicker";
import DateTimePicker from 'react-datetime-picker';
import fr from "date-fns/locale/fr";
import de from "date-fns/locale/de";

registerLocale("fr", fr);
registerLocale("de", de);

export const ProfileDateBox = (props) => {
    return (
        <div className={classes.Row}>
            <div className={classes.ColumnsFour}>
                <label className={classes.HeadingLb}>{<FormattedMessage id={props.fMsgId} />}</label>
            </div>
            <div className={classes.ColumnsEight}>
                <div className={classes.UpDatePicker} style={{ width: '80%', height: '2.0em', marginTop: '0.2em', marginBottom: '0.2em' }}>
                    <DatePicker dateFormat="d.MM.yyyy" selected={props.selectedDate} onChange={props.onChangeDate} ref={props.refDate}
                        minDate={DataUtil.setMinMaxDate(props.minDate)} maxDate={DataUtil.setMinMaxDate(props.maxDate)}
                        popperPlacement="top-start" popperModifiers={{ flip: { behavior: ["top-start"] }, preventOverflow: { enabled: false }, hide: { enabled: false } }} />
                    <span><img alt="" className={classes.CalendarIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "calendarIcon")} onClick={props.onClickDate}></img></span>
                </div>
            </div>
        </div>
    )
}

export const ProfileInput = (props) => {
    return (
        <div className={classes.Row}>
            <div className={classes.ColumnsFour}>
                <label className={classes.HeadingLb}>{<FormattedMessage id={props.fMsgId} />}</label>
            </div>
            <div className={classes.ColumnsEight}>
                <FormattedMessage id={props.fMsgId}>
                    {(Msg) => <input type={props.type} name={props.name} value={props.value} onChange={props.onChange} placeholder={Msg} disabled={props.isDisabled} />}
                </FormattedMessage>
            </div>
        </div>
    )
}

export const ProfileSelect = (props) => {
    return (
        <div>
            <div className={classes.Row}>
                <div className={classes.ColumnsFour}>
                    <p className={classes.OnOffHeading}>{<FormattedMessage id={props.fMsgId} />}</p>
                </div>
                <div className={classes.ColumnsEight}>

                    <select name={props.name} false="" type="dropdown" value={props.value} onChange={props.onChange} >
                        <FormattedMessage id="data.chooseLb">
                            {(Msg) => <option value="">{Msg}</option>}
                        </FormattedMessage>
                        {props.data.map((item, index) => {
                            return (<option key={index} value={item}>{item}</option>)
                        })
                        }
                    </select>
                </div>
            </div>
        </div>
    )
}

export const CustomSelect = (props) => {
    let data = props.data;
    let lg = DataUtil.getLanguage(props.lg);
    let iconShow = CustomMedia.toggleArrowIcon(props.display);
    return (
        <div>
            <div className={classes.Row}>
                <div className={classes.ColumnsFour}>
                    <p className={classes.OnOffHeading}>{<FormattedMessage id={props.fMsgId} />}</p>
                </div>
                <div className={classes.DataListBox}>
                    <div className={classes.dropdown}>
                        <div style={props.requiredField ? CustomTypes.BORDER_RED : null} className={classes.DataListRow}>
                            <FormattedMessage id={props.fMsgId}>
                                {(Msg) => <input className={classes.dropInput} style={CustomTypes.WIDTH_FULL} type="text" value={props.inputValue} onChange={props.onDdInputChange} onClick={props.onDdIputClick} placeholder={Msg} />}
                            </FormattedMessage> <span> <img alt="" className={classes.DataListIcons} src={iconShow} onClick={props.onDdInputClick}></img></span></div>
                        <div className={classes.dropdownContent} style={{ display: props.display }}>
                            {(((data) && (data.length) > 0)) ? (data.map((item, index) => (<input style={{ width: '100%' }} key={index} type={props.type} onClick={props.onDataClick} value={item[lg]} name={DataUtil.getId(item)} />))) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const CustomStandardSelect = (props) => {
    let lg = DataUtil.getLanguage(props.lg);
    return (
        <div>
            <div className={classes.Row}>
                <div className={classes.ColumnsFour}>
                    <p className={classes.OnOffHeading}>{<FormattedMessage id={props.fMsgId} />}</p>
                </div>
                <div className={classes.ColumnsEight}>

                    <select name={props.name} false="" type="dropdown" value={props.value} onChange={props.onChange} >
                        <FormattedMessage id="data.chooseLb">
                            {(Msg) => <option value="">{Msg}</option>}
                        </FormattedMessage>
                        {props.data.map((item, index) => {
                            return (<option key={index} value={DataUtil.getId(item)}>{item.intl && props.formatMessage ? props.formatMessage({ id: item.intl }) : item[lg]}</option>)
                        })
                        }
                    </select>
                </div>
            </div>
        </div>
    )
}

export const CustomStandardSelectWithIcon = (props) => {
    let lg = DataUtil.getLanguage(props.lg);
    return (
        <div className={classes.CustomSelectRow}>
            <FontAwesomeIcon icon={faUsers} style={{ fontSize: "18px" }} />
            <select style={{ paddingLeft: "0", border: "none" }} name={props.name} false="" type="dropdown" value={props.value} onChange={props.onChange} >
                {/* <FormattedMessage id="data.chooseLb">
                    {(Msg) => <option value="">{Msg}</option>}
                </FormattedMessage> */}
                {props.data.map((item, index) => {
                    return (<option key={index} value={DataUtil.getId(item)}>{item[lg]}</option>)
                })
                }
            </select>
        </div>
    )
}


export const CustomNotificationGroup = (props) => {
    const colorOn = "#c73333";
    const colorOff = "#c8c8c8";
    return (
        <div className={classes.CustomContainer}>
            <div className={classes.CustomRow}>
                <div className={classes.CustomColumnsFour}>
                    {props.header == "" ? (<label className={classes.CustomHeading}><br /></label>) : (<label className={classes.CustomHeading}>{<FormattedMessage id={props.header} />}</label>)}
                </div>
                <div className={classes.CustomColumnsFour}>
                    <label className={classes.SubHeading}>{props.subheader ? <FormattedMessage id={props.subheader} /> : ""}</label>
                </div>
                <div className={classes.CustomColumnsFour}>
                    <div className={classes.CustomButtonGroup}>
                        <FormattedMessage id="profile.offLb">
                            {(offMsg) => {
                                if (props.data) return <button name={props.name} className={classes.CustomOffBtn} onClick={props.btnClick} style={{ backgroundColor: colorOff }} >{offMsg}</button>
                                else return <button name={props.name} className={classes.CustomOffBtn} onClick={props.btnClick} style={{ backgroundColor: colorOn }} >{offMsg}</button>
                            }}
                        </FormattedMessage>
                        <FormattedMessage id="profile.onLb">
                            {(onMsg) => {
                                if (props.data) return <button name={props.name} className={classes.CustomOnBtn} onClick={props.btnClick} style={{ backgroundColor: colorOn }} >{onMsg}</button>
                                else return <button name={props.name} className={classes.CustomOnBtn} onClick={props.btnClick} style={{ backgroundColor: colorOff }} >{onMsg}</button>
                            }}
                        </FormattedMessage>
                    </div>

                </div>
            </div>
        </div>
    )
}

export const CustomMessageBox = (props) => {
    return (<div className={DataUtil.isPMDB() ? classes.UnlimitedMsg : classes.CustomAppMsg} style={{ display: props.display }}>
        <span>{<FormattedMessage id={props.fMsgId} />}</span>
    </div>)
}

export const CustomRequiredField = (props) => {
    let isVisible = false;

    if ((props.customdisplay && props.customdisplay === props.condition.value && props.customdisplay !== "customdisplay" && props.condition.required) || props.mandatory
        || (props.customdisplay && props.customdisplay.includes(props.condition.value) && props.customdisplay !== "customdisplay" && props.condition.required))
        isVisible = true;

    return <span style={{ color: 'red' }}>{isVisible ? CustomTypes.STAR : null}</span>
}


export const CustomSearchButtonsBoxWithSpinner = (props) => {
    let isLoading = false;
    return (
        <div className={classes.CustomRightButtonsContainer}>
            {DataUtil.isPMDB() ? <div className={classes.InfoSpinnerBox} />
                : <div className={classes.InfoSpinnerBox} onClick={props.onLogFileClick}>
                    <CustomSpinner isLoading={isLoading} />
                    <FontAwesomeIcon className={classes.InfoIcon} icon={CustomAppEventListener(CustomEvents.GET_AWE_ICON, "faInfo")} />
                </div>}
            <div className={classes.CustomRightButtonsBoxWithSpinner}>
                <div className={classes.CustomButtonsBoxWithSpinner}>
                    <button className={classes.CustomBlackBtn} onClick={props.onCancelClick} >
                        <FontAwesomeIcon icon={CustomAppEventListener(CustomEvents.GET_AWE_ICON, "faTimes")} style={CustomTypes.BUTTON_ICON} />
                        <span className={classes.BtnBlackLb} >{<FormattedMessage id="customdata.dicardchanges" />}</span>
                    </button>
                    <button className={classes.CustomRedBtn} onClick={props.onSubmitClick}>
                        <div className={classes.CusomDataFlexBox}> <FontAwesomeIcon icon={"chevron-right"} style={CustomTypes.BUTTON_ICON} /><span className={classes.BtnLb}> {<FormattedMessage id={props.fMsgIdSubmit} />} </span>
                        </div>
                    </button>
                </div>
            </div>
        </div>

    )
}

export const CustomRightButtonsBox = (props) => {
    return (
        <div className={classes.CustomRightButtonsBox}>
            <div className={classes.CustomButtonsBox}>
                <button style={{ width: '45%' }} className={classes.CustomWhiteBtn} onClick={props.onCancelClick} >
                    <FontAwesomeIcon icon={CustomAppEventListener(CustomEvents.GET_AWE_ICON, "faTimes")} style={CustomTypes.BUTTON_ICON} />
                    <span className={classes.BtnBlackLb} >{props.formStatus ? <FormattedMessage id={props.fMsgIdCancel} /> : <FormattedMessage id="data.closeLb" />}</span></button>
                <button style={{ width: '45%' }} className={classes.CustomRedBtn} onClick={props.onSubmitClick}>
                    <div className={classes.CusomDataFlexBox}><FontAwesomeIcon style={CustomTypes.BUTTON_ICON} icon={CustomAppEventListener(CustomEvents.GET_AWE_ICON, "faArrowUp")} />
                        <span className={classes.BtnLb}> {<FormattedMessage id={props.fMsgIdSubmit} />} </span>
                    </div>
                </button>
            </div>
        </div>
    )
}

export const CustomLeftButtonsBox = (props) => {
    return (
        <div className={classes.CustomLeftButtonsBox}>
            <div className={classes.CustomButtonsBox}>

                <button style={{ width: '40%' }} className={classes.CustomRedBtn} onClick={props.onSubmitClick}>
                    <div className={classes.CusomDataFlexBox}>{DataUtil.isPMDB() ? <div /> : <img alt="" className={classes.DataIcons} src={props.submitImgSrc} />}<span className={classes.BtnLb}> {<FormattedMessage id={props.fMsgIdSubmit} />} </span>
                    </div>
                </button>
                <button style={{ width: '40%' }} className={classes.CustomBlackBtn} onClick={props.onCancelClick} > <span className={classes.BtnBlackLb} >{<FormattedMessage id={props.fMsgIdCancel} />}</span></button>
            </div>
        </div>
    )
}

export const CustomCenterButtonsBox = (props) => {
    return (
        <div className={classes.CustomCenterButtonsBox}>
            <button style={props.style ? props.style : { width: '20%' }} className={classes.CustomBlackBtn} onClick={props.onCancelClick} ><FontAwesomeIcon icon={CustomAppEventListener(CustomEvents.GET_AWE_ICON, "faTimes")} style={{ marginRight: "5px", fontSize: "14px" }} /> <span className={classes.BtnBlackLb} >{props.formStatus ? <FormattedMessage id={props.fMsgIdCancel} /> : <FormattedMessage id="data.closeLb" />}</span></button>
            <button style={props.style ? props.style : { width: '20%' }} className={classes.CustomRedBtn} onClick={props.onSubmitClick}>
                <div className={classes.CusomDataFlexBox}><FontAwesomeIcon style={CustomTypes.BUTTON_ICON} icon={CustomAppEventListener(CustomEvents.GET_AWE_ICON, "faArrowUp")} /><span className={classes.BtnLb}> {<FormattedMessage id={props.fMsgIdSubmit} />} </span>
                </div>
            </button>
        </div>
    )
}

export const CustomLogoSection = (props) => {
    return (<div className={classes.CustomLogoSection}>
        <div className={classes.LogoSection}>
            <div><img alt="" className={classes.Logo} src={props.imgsrc} /></div>
            <div><p className={classes.LogoTitle}>{props.label ? props.label : <FormattedMessage id={props.fMsgId} />}</p></div>
        </div>
        <div><img alt="" className={classes.CancelIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "cancelIcon")} onClick={props.onClick} /> </div>
    </div>)
}


export const CustomLargeLogoSection = (props) => {
    let masterClipTitle;
    if (props.masterClipTitle)
        masterClipTitle = DataUtil.sliceName(props.masterClipTitle, 30);
    else masterClipTitle = DataUtil.sliceName(props.masterClipId, 30);

    if (props.formDesign && props.formDesign === CustomTypes.MASTER_UPLOAD_FORM)
        return <p className={classes.LogoTitleLabelChild}>{props.formTitle ? props.formTitle : null} : {masterClipTitle} </p>
    else
        return <p className={classes.LogoTitleLabelPMDB}>{props.formTitle ? props.formTitle : null} </p>
}

export const CustomSubmenuBox = (props) => {
    let iconShow = CustomMedia.getSubMenuIcon(props.display);
    if ((props.formDesign && props.formDesign === CustomTypes.MASTER_UPLOAD_FORM) && !DataUtil.isFrancetv())
        return <div></div>

    else if (props.formDesign && props.formDesign === CustomTypes.SEARCH_FORM && DataUtil.isPMDB()) {
        return (<div className={classes.SubMenuTitle}>
            <p style={{ marginTop: '0px' }} className={classes.DataLabelGrey} >{<FormattedMessage id={props.fMsgId} />}
                <div />
            </p>
        </div>)
    }
    else
        return (<div className={classes.SubMenuTitle}>
            <p style={{ marginTop: '0px' }} className={classes.DataLabel} >{<FormattedMessage id={props.fMsgId} />}
                <img alt="" className={classes.ShowIcons} src={iconShow} onClick={props.onSubmenuIconClick} />
            </p>
        </div>)
}


export const CustomSelectFilesButton = (props) => {
    const inputOpenFileRef = React.createRef();
    const showOpenFileDlg = () => {
        inputOpenFileRef.current.click();
    };
    return (
        <div>
            <input ref={inputOpenFileRef} type="file" style={{ display: "none" }} onChange={props.onChangeFile} multiple />
            <button className={(props.formDesign === CustomTypes.MASTER_UPLOAD_FORM) ? classes.FilesSearchBtnChild : classes.FilesSearchBtn} onClick={showOpenFileDlg} >
                {" "}
                <span className={classes.BtnLb}>
                    {<FormattedMessage id="upload.filesSearchLb" />}
                </span>{" "}
                <img alt="" className={classes.SearchFileIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "searchfileIcon")} />
            </button>
        </div>)
}


export const UploadProgressBarWithThumbs = (props) => {
    let divElementId = DataUtil.setIdForDivElement(props);
    let deleteIconId = DataUtil.getDeleteIconId(divElementId);
    let deleteIcon = CustomMedia.getIconForApp("deleteOff");
    return (
        <div className={classes.FlexProgressBarEntry} id={divElementId} onClick={() => props.onSelectedFileClick(props.elementList, divElementId)}>
            <div className={classes.ThumbsBox}><CustomMedia.CustomDataThumbnail classes={classes} fileType={props.file.type} url={props.url} /></div>

            <div className={classes.textBox}>
                <label className={classes.ellipsis} data-text={props.header}>{props.header}</label>
            </div>

            <div className={classes.FlexProgress}>
                <div id={props.id} className={classes.FlexBar} >
                </div>
            </div>
            <p className={classes.FlexText} id={props.pId} > </p>
            <div className={classes.FlexIconContainer}><img id={deleteIconId} className={classes.FlexDeleteIcon} src={deleteIcon} alt="delete" onClick={() => { props.onDeleteIconClick(divElementId); }} /></div>
        </div>
    )
}

export const CustomSpinner = (props) => {
    return (
        <div className={props.isLoading ? classes.CustomSpinnerActive : classes.CustomSpinnerSleep} >
            <div className={classes.CustomSpinner} >
                <div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div /><div />
            </div>
        </div>)
}


export const showBuff = () => {
    if (isPorscheArchiv()) return null;
    return <div />
}
export const CustomDragDropUploadBox = (props) => {
    let isLoading = false;
    if (props.uploadInfo && props.uploadInfo.isLoading) isLoading = true;
    return (
        <div className={classes.UploadDragFilesContainer}>
            <div className={(props.formDesign === CustomTypes.MASTER_UPLOAD_FORM) ? classes.UploadDragFilesChild : classes.UploadDragFiles}>
                <div className={classes.DragFilesHeaderBlock}>
                    {
                        (props.formDesign === CustomTypes.MASTER_UPLOAD_FORM || isFrancetv()) ? showBuff() :
                            <div className={classes.SwitchBox}>
                                <div className={classes.clipToggleBt}>
                                    <label className={classes.switch}>
                                        <input type="checkbox" name="oneClip" value={props.customDataObjects.oneClip} onChange={props.onGetCheckedItem} checked={props.customDataObjects.oneClip} />
                                        <span className={classes.slider + " " + classes.round} />
                                    </label>
                                </div>
                                {<p>{<FormattedMessage id="data.OneClipLb" />}</p>}
                            </div>
                    }
                    {isPorscheArchiv() && (
                        <div className={classes.OcrBox}>
                            <CustomCheckBox fMsgId={props.advName} type="checkbox" name={props.advName}
                                value={props.customDataObjects.ocr} onChange={props.onAdvCheck} checked={props.customDataObjects.ocr} />
                        </div>
                    )}
                    <div className={classes.DeleteBox}><span><FormattedMessage id="customdata.clearAllLb" /></span>
                        <img alt="" className={classes.ClearAllIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "clearAllIcon")} onClick={props.onClearFiles} /></div>
                </div>
                <div>
                    <CustomDragDropBox addFile={props.addFile} files={props.files} />
                </div>
                <div className={(props.formDesign === CustomTypes.MASTER_UPLOAD_FORM) ? classes.CustomFilesBoxChild : classes.CustomFilesBox}>
                    {props.customDataObjects.selectedObjects.map(
                        (item, index) => (
                            <UploadProgressBarWithThumbs elementList={props.customDataObjects.selectedObjects} fileObject={item} key={index} url={item.url} file={item.file} id={"pB" + index} header={item.name} uploading={props.uploading} pId={"p" + index}
                                onDeleteIconClick={props.onDeleteIconClick}
                                onSelectedFileClick={props.onSelectedFileClick}
                            />
                        )
                    )}
                    {/*<p id={props.id} className={classes.UploadedLb} />*/}
                </div>
            </div>
            <div className={(props.formDesign === CustomTypes.MASTER_UPLOAD_FORM) ? classes.InfoSectionChild : classes.InfoSection}>
                <div className={classes.InfoTextBox}><p id={props.id} className={classes.UploadedLb} onClick={props.onLogFileClick} /></div>
                <div className={classes.InfoSpinnerBox} onClick={props.onLogFileClick}>
                    <CustomSpinner isLoading={isLoading} />
                    <FontAwesomeIcon className={(props.formDesign === CustomTypes.MASTER_UPLOAD_FORM) ? classes.InfoIcon : classes.InfoIconBig}
                        style={{ marginTop: "10px" }}
                        icon={CustomAppEventListener(CustomEvents.GET_AWE_ICON, "faInfo")} />
                </div>
            </div>
        </div>)
}


export const CustomClearAllBox = (props) => {
    return (<div className={classes.FormSubmenuHeading}>
        {(props.formDesign && props.formDesign === CustomTypes.MASTER_UPLOAD_FORM || props.formDesign === CustomTypes.SEARCH_FORM) ? <p /> : <p><FormattedMessage id={props.fMsgId} /></p>}
        <div>
            {((DataUtil.isPMDB() || DataUtil.isPorscheArchiv()) && props.formDesign === CustomTypes.SEARCH_FORM) ? <div /> : <img alt="" className={classes.ClearAllIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "clearAllIcon")} onClick={props.onClearAllData} />}
        </div>
    </div>)
}


export const CustomDropDownHeaderWithDeleteBtn = (props) => {
    let isPrefix = false;
    if (DataUtil.isPorscheArchiv() && props.name === `${fTypes.ARCHIV_FIELD}_tmp`) {
        isPrefix = true;
    }
    return (
        <div className={classes.CheckBoxListEntry}>
            {props.hideLabel ? null : <label className={classes.DataHeading}>{props.header}{isPrefix && '-Prefix'}<CustomRequiredField {...props} /></label>}
            <div style={props.requiredField ? CustomTypes.BORDER_RED : null} className={classes.DataContentsListRow}>
                <FormattedMessage id={props.fMsgId}>
                    {(Msg) => <div className={classes.DataListRow}>
                        <input style={{ width: '100%', border: 'none' }} type={props.type} name={props.name} value={props.value}
                            onChange={props.onChange} placeholder={`${Msg}${isPrefix ? '-Prefix' : ''}`} disabled={props.disabled} />
                        <span>
                            <img alt="" className={classes.DataDeleteIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "DeleteButton")} onClick={props.onDeleteClick}></img></span><span>
                            <img alt="" className={classes.DataListIcons} src={props.src} onClick={props.onClick}></img>
                        </span>
                    </div>}
                </FormattedMessage>
            </div>
        </div>
    )
}

export const CustomDropDownFadeBoxHeader = (props) => {
    return (
        <div className={classes.CheckBoxListEntry}>
            <label className={classes.DataHeading}>{props.header}</label>
            <div style={props.requiredField ? CustomTypes.BORDER_RED : null} className={classes.DataContentsListRow}>
                <FormattedMessage id={props.fMsgId}>
                    {(Msg) => <div className={classes.DataListRow}><input type={props.type} name={props.name} value={props.value} onChange={props.onChange} placeholder={Msg} disabled={props.disabled} /><span> <img alt="" className={classes.DataListIcons} src={props.src} onClick={props.onClick}></img></span></div>}
                </FormattedMessage>
            </div>
        </div>
    )
}

export const CustomResizableTextArea = (props) => {
    return (
        <div className={classes.DataFlexBox}>
            <label className={classes.DataHeading}>{<FormattedMessage id={props.fMsgId} />}<CustomRequiredField {...props} /></label>
            <textarea style={props.requiredField ? CustomTypes.BORDER_RED : null} className={classes.ResizableTextAreaDiv} name={props.name} value={props.value} onChange={props.onChange} rows={props.rows} id={props.id} />
        </div>)
}

export const CustomInvertedButton = (props) => {
    return (
        <div className={classes.DataFlexBox}>
            <button className={classes.DataInvertedButton + ' ' + classes.LargeButton} name={props.name} value={props.value} onClick={props.onClick}>{props.header}</button>
        </div>)
}

export const CustomDataImage = (props) => {
    return (
        <div className={classes.DataFlexBox}>
            {props.fMsgId ? (<label className={classes.DataHeading}>{<FormattedMessage id={props.fMsgId} />}</label>)
                : (<label className={classes.DataHeading}></label>)}
            <div className={classes.IconsDiv}>
                <div></div>
                <div><img alt="" className={classes.CancelIcons} src={props.src} onClick={props.onClick} style={props.customStyle ? props.customStyle : null} /> </div>
            </div>
        </div>)
}


export const CustomDataInput = (props) => {
    let isPrefix = false;
    if (DataUtil.isPorscheArchiv() && props.name === `${fTypes.ARCHIV_FIELD}` && props.isUpload) {
        isPrefix = true;
    }
    let addObj = {};
    if (props.addObj) addObj = { ...props.addObj };
    if ((props.customdisplay && props.customdisplay === props.condition.value) || (!isFrancetv() && !isNLW()))
        return (
            <div className={classes.DataFlexBox}>
                <label className={classes.DataHeading}>{props.label ? props.label : <FormattedMessage id={props.fMsgId} />}{isPrefix && '-Prefix'}<CustomRequiredField {...props} /></label>
                <input style={props.requiredField ? CustomTypes.BORDER_RED : null} type={props.type} name={props.name} value={props.value}
                    onChange={props.onChange} defaultChecked={props.defaultChecked} disabled={props.disabled}
                    placeholder={props.showPlaceholder && props.showPlaceholder} {...addObj} />
            </div>)
    else
        return (<div></div>)
}

export const CustomDataInputWithIcon = (props) => {
    return (
        <div className={classes.CheckBoxListEntry}>
            <label className={classes.DataHeading}>{<FormattedMessage id={props.fMsgId} />}</label>
            <div className={classes.CheckBoxList}>
                <FormattedMessage id={props.fMsgId}>
                    {(Msg) => <div className={classes.InputIconBox}><input type={props.type} style={{ width: '97%', height: '2.2em' }} name={props.name} value={props.value} onChange={props.onChange} disabled={props.disabled} /><img alt="" className={classes.InputIconBoxIcon} src={props.src} onClick={props.onClick}></img></div>}
                </FormattedMessage>
            </div>
        </div>)
}

export const CustomDataInputWithBtn = (props) => {
    return (
        <div className={classes.CheckBoxListEntry}>
            <label className={classes.DataHeading}>{<FormattedMessage id={props.fMsgId} />}</label>
            <div className={classes.CheckBoxList}>
                <FormattedMessage id={props.fMsgId}>
                    {(Msg) => (
                        <div className={classes.InputIconBox}>
                            <input type={props.type} style={{ width: '97%', height: '2.2em' }} name={props.name} value={props.value} disabled={true} />
                            <span>
                                <img alt="" className={classes.DataDeleteIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "DeleteButton")}
                                    onClick={props.onDeleteClick}></img></span><span>
                            </span>
                            <div className={classes.InputBtn} src={props.src} onClick={props.onInputBtnClick}>
                                <FontAwesomeIcon icon={faObjectGroup} />
                            </div></div>
                    )}
                </FormattedMessage>
            </div>
        </div>)
}

export const CustomClassicDropdown = (props) => {
    return (
        <div className={classes.DataListEntry} >
            <label className={classes.DataHeading}>
                {props.label ? props.label : <FormattedMessage id={props.fMsgId} />}
                <CustomRequiredField {...props} />
            </label>
            <div className={classes.DataListBox}>
                <Dropdown data={props.data} current={props.value} required={false} error={false}
                    isClassic={true} onDDClick={props.onClick} />
            </div>
        </div>
    )
}

export const CustomDropDown = (props) => {
    try {
        let data = props.data;
        let lg = DataUtil.getLanguage(props.lg);
        let iconShow = CustomMedia.toggleArrowIcon(props.display);
        if (props.sorted) data = DataUtil.sortData(props.data, lg);

        if ((props.customdisplay && props.customdisplay === props.condition.value && props.container && props.container === props.condition.ext.value)
            || (props.customdisplay && props.customdisplay.includes(props.condition.value))
            || (props.customdisplayextends && props.customdisplayextends.includes(props.condition.value) && props.container && props.container === props.condition.ext.value)
            || (!isFrancetv() && !isNLW()))
            return (
                <div className={classes.DataListEntry} >
                    <label className={classes.DataHeading}>{props.label ? props.label : <FormattedMessage id={props.fMsgId} />}<CustomRequiredField {...props} /></label>
                    <div className={classes.DataListBox}>
                        <div className={classes.dropdown}>
                            <div style={props.requiredField ? CustomTypes.BORDER_RED : null} className={classes.DataListRow}>
                                <FormattedMessage id={props.fMsgId}>
                                    {(Msg) => <input className={classes.dropInput} style={CustomTypes.WIDTH_FULL} type="text" value={props.inputValue} onChange={props.onDdInputChange} onClick={props.onDdIputClick} placeholder={Msg} />}
                                </FormattedMessage> <span><img alt="" className={classes.DataDeleteIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "DeleteButton")} onClick={props.onDeleteClick}></img></span><span> <img alt="" className={classes.DataListIcons} src={iconShow} onClick={props.onDdInputClick}></img></span></div>
                            <div className={classes.dropdownContent} style={{ display: props.display }}>
                                {(((data) && (data.length) > 0)) ? (data.map((item, index) => (<input style={{ width: '100%' }} key={index} type={props.type} onClick={props.onDataClick} value={item[lg]} name={DataUtil.getId(item)} />))) : null}
                            </div>
                        </div>
                    </div>
                </div>
            )

        return (<div></div>)
    } catch (error) {
        console.log("CustomDropDown ERROR!");
        return (<div></div>)
    }
}


export const CustomDropDownWithAddButton = (props) => {
    let data = props.data;
    let lg = DataUtil.getLanguage(props.lg);
    let iconShow = CustomMedia.toggleArrowIcon(props.display);
    if (props.sorted) data = DataUtil.sortData(props.data, lg);

    if ((props.customdisplay && props.customdisplay === props.condition.value) || (!isFrancetv() && !isNLW()))
        return (
            <div className={classes.DataListEntry}>
                <label className={classes.DataHeading}>{props.label ? props.label : <FormattedMessage id={props.fMsgId} />}<CustomRequiredField {...props} /></label>
                <div className={classes.DataListBox}>
                    <div className={classes.dropdown}>
                        <div style={props.requiredField ? CustomTypes.BORDER_RED : null} className={classes.DataListRow}>
                            {props.isLoading && <div className={classes.CustomLoader} />}
                            <FormattedMessage id={props.fMsgId}>
                                {(Msg) => <input className={classes.dropInput} style={CustomTypes.WIDTH_FULL} type="text"
                                    value={props.inputValue} onChange={props.onDdInputChange} onClick={props.onDdIputClick} placeholder={Msg} />}
                            </FormattedMessage> <span>
                                <img alt="" className={classes.DataDeleteIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "DeleteButton")}
                                    onClick={props.onDeleteClick}></img></span><span> <img alt="" className={classes.DataDeleteIcons}
                                        src={CustomAppEventListener(CustomEvents.GET_ICON, "AddButton")} onClick={props.onAddClick}></img>
                            </span> <span> <img alt="" className={classes.DataListIcons} src={iconShow} onClick={props.onDdInputClick}></img></span></div>
                        <div className={classes.dropdownContent} style={{ display: props.display, paddingBottom: '4rem' }}>
                            {(((data) && (data.length) > 0)) ? (data.map((item, index) => (
                                <input style={item.showLevel ? { width: '100%', paddingLeft: `${parseInt(item.showLevel) * 10}px` } : { width: '100%' }}
                                    key={index} type={props.type} onClick={props.onDataClick} value={item[lg]} name={DataUtil.getId(item)} />))) : null}
                        </div>
                    </div>
                </div>
            </div>
        )

    return (<div></div>)
}

export const CustomDataFadeBox = (props) => {
    let lg = DataUtil.getLanguage(props.lg);
    return (
        <div className={classes.CheckBoxListEntry}>
            {props.fMsgId ? (<label className={classes.DataHeading}>{<FormattedMessage id={props.fMsgId} />}</label>) : null}
            <div className={classes.DropDownList}>
                {(((props.data) && (props.data.length) > 0)) ? (props.data.map((item, index) => <input key={index} type={props.type}
                    style={item.showmodel ? { color: 'red', width: '100%' } : { marginLeft: '1.2em', width: '100%', border: 'none' }}
                    value={item.intl && props.formatMessage ? props.formatMessage({ id: item.intl }) : item[lg]}
                    name={item.ID} onClick={props.onDataClick} />)) : null}
            </div>
        </div>
    )
}


export const CustomFadeBoxContainer = (props) => {
    let lg = DataUtil.getLanguage(props.lg);
    return (<div>
        {props.data.map((item, i) => {
            let itemContent = item.intl && props.formatMessage ? props.formatMessage({ id: item.intl }) : item[lg];
            let content = DataUtil.sliceShortName(itemContent, 15);
            return (
                <CustomFadeBox id={item.ID} key={content} value={item.intl && props.formatMessage ? props.formatMessage({ id: item.intl }) : item[lg]}
                    onRemove={props.onRemove} />
            )
        })}
    </div>)
}


export const CustomDropdownWithFadeBox = (props) => {
    let data = props.data || [];
    let lg = DataUtil.getLanguage(props.lg);
    let iconShow = CustomMedia.toggleArrowIcon(props.display);
    let btnTxt = props.formatMessage({ id: "customdata.closeMsg" });
    if (props.sorted) data = DataUtil.sortData(props.data, lg);

    let selectall = false;
    if (props.advanced && props.advanced.selectall) selectall = true;
    try {
        if ((props.customdisplay && props.customdisplay === props.condition.value)
            || (props.customdisplay && props.customdisplay.includes(props.condition.value)) || (!isFrancetv() && !isNLW()))
            return (<div className={classes.ApiSection}>
                <div className={classes.DataCheckBoxDiv}>
                    <div className={classes.DataCheckHeaderBox}>
                        <CustomDropDownHeaderWithDeleteBtn header={<FormattedMessage id={props.fMsgId} />} fMsgId={props.fMsgId} type="text"
                            value={props.inputValue} name={`${props.name}_tmp`} src={iconShow} onChange={props.onDdInputChange} hideLabel={props.hideLabel}
                            onClick={props.onDdInputClick} onDeleteClick={props.onDeleteClick} requiredField={props.requiredField} condition={props.condition}
                            customdisplay={props.customdisplay} mandatory={props.mandatory} />
                        <div className={classes.FadeBoxSection}>
                            {props.hideLabel ? null : <div className={classes.Row4} />}
                            <div className={classes.Row6}>
                                <CustomFadeBoxContainer lg={props.lg} data={props.dataItems ? props.dataItems : []}
                                    onRemove={props.onDdRemoveItems} formatMessage={props.formatMessage} />
                            </div>
                        </div>
                    </div>
                    <div className={classes.DataCheckBodyBox + " " + classes.SubContainer} style={props.hideLabel ? { marginLeft: '0' } : { marginLeft: '30%' }}>
                        <div className={classes.DataCheckBoxContents} style={{ display: props.display }} >
                            {selectall && <div className={classes.DropdownSelectAllBtn} onClick={props.onDDSelectAllClick} >
                                {<FormattedMessage id="data.selectall" />}
                            </div>}
                            <CustomDataFadeBox formatMessage={props.formatMessage} lg={props.lg} name={props.name} type="text"
                                onDataClick={props.onDataClick} data={data} />
                            <CustomInvertedButton fMsgId="" header={btnTxt} onClick={props.onDdInputClick} />
                        </div>
                    </div>
                </div></div >)

        return (<div></div>)
    } catch (error) {
        return (<div></div>)
    }
}

export const CustomCheckBox = (props) => {
    return (
        <div className={classes.DataFlexBox}>
            <label className={classes.DataHeading}>{props.label ? props.label : <FormattedMessage id={props.fMsgId} />}</label>
            <div className={classes.DataCheckBox}>
                <input style={{ marginLeft: '0px' }} type="checkbox" name={props.name} value={props.value} onChange={props.onChange} defaultChecked={props.defaultChecked} checked={props.checked} />
            </div>
        </div>)
}

export const CustomCheckBoxSm = (props) => {
    return (
        <div className={classes.DataFlexBoxSm}>
            <label className={classes.DataHeading}>{props.label ? props.label : <FormattedMessage id={props.fMsgId} />}</label>
            <div className={classes.DataCheckBoxSm}>
                <input style={{ marginLeft: '0px' }} type="checkbox" name={props.name} value={props.value} onChange={props.onChange} defaultChecked={props.defaultChecked} checked={props.checked} />
            </div>
        </div>)
}

export const CustomOutsideCheckBox = (props) => {
    return (
        <div className={classes.CustomCheckBoxContainer}>
            <div className={classes.CustomCheckBoxSection}>
                <input type="checkbox" name={props.name} value={props.value} onChange={props.onChange} defaultChecked={props.defaultChecked} checked={props.checked} />
                <p style={{ fontSize: '12.5px' }}>{props.label ? props.label : <FormattedMessage id={props.fMsgId} />}</p>
            </div>
        </div>)
}


export const CustomDateGroup = (props) => {
    try {
        const refFrom = React.createRef();
        const refTo = React.createRef();
        let datePosFirst = props.datePosFirst ? props.datePosFirst : "top-start";
        let datePosSecond = props.datePosSecond ? props.datePosSecond : "top-end";
        let selectedTo = DataUtil.isIsoString(props.selectedTo) ? moment(props.selectedTo).toDate() : props.selectedTo;
        let selectedFrom = DataUtil.isIsoString(props.selectedFrom) ? moment(props.selectedFrom).toDate() : props.selectedFrom;
        let appDateFormat = CustomForm.getDateFormatForApp(props.uiConfig);
        let locale = props.lg ? props.lg : "en";
        return (
            <div className={classes.DataFlexBox}>
                {props.hideLabel ? null : <label className={classes.DataHeading}>{props.label ? props.label : <FormattedMessage id={props.fMsgId} />}<CustomRequiredField {...props} /></label>}
                <div className={classes.DataDatePicker} style={props.requiredField ? CustomTypes.BORDER_RED : null}>
                    <div className={classes.DateGroupBox}>
                        <span>{<FormattedMessage id="expertsearch.From" />}</span>
                        <DatePicker locale={locale} placeholderText={DataUtil.isPMDB() ? null : appDateFormat.toUpperCase()} dateFormat={appDateFormat} ref={refFrom} selected={selectedFrom}
                            minDate={DataUtil.setMinMaxDate(props.minDate)} maxDate={DataUtil.setMinMaxDate(props.maxDate)} onChange={props.onChangeFrom}
                            popperPlacement={datePosFirst} popperModifiers={{ flip: { behavior: ["top-start"] }, preventOverflow: { enabled: false }, hide: { enabled: false } }} />
                        <span><img alt="" className={classes.CalendarIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "calendarIcon")} onClick={() => refFrom.current.setOpen(true)}></img></span>
                    </div>
                    <div className={classes.DateGroupBox}>
                        <span>{<FormattedMessage id="expertsearch.To" />}</span>
                        <DatePicker locale={locale} placeholderText={DataUtil.isPMDB() ? null : appDateFormat.toUpperCase()} dateFormat={appDateFormat} ref={refTo} selected={selectedTo}
                            minDate={DataUtil.setMinMaxDate(props.minDate)} maxDate={DataUtil.setMinMaxDate(props.maxDate)} onChange={props.onChangeTo}
                            popperPlacement={datePosSecond} popperModifiers={{ flip: { behavior: ["top-start"] }, preventOverflow: { enabled: false }, hide: { enabled: false } }} />
                        <span><img alt="" className={classes.CalendarIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "calendarIcon")} onClick={() => refTo.current.setOpen(true)} ></img></span>
                    </div>
                </div>
            </div>
        )
    } catch (error) {
        return (<div></div>)
    }
}

export const CustomDateBox = (props) => {
    try {
        let datePosition = props.datePos ? props.datePos : "top-start";
        //let datePosition = "bottom-start";
        let appDateFormat = CustomForm.getDateFormatForApp(props.uiConfig);
        const refDate = React.createRef();
        let selectedDate = DataUtil.isIsoString(props.selectedDate) ? moment(props.selectedDate).toDate() : props.selectedDate;
        let locale = props.lg ? props.lg : "en";
        return (
            <div className={classes.MetadataEntry} >
                {props.hideLabel ? null : <label className={classes.HightLightLb}>{props.label ? props.label : <FormattedMessage id={props.fMsgId} />}<CustomRequiredField {...props} /></label>}
                <div className={classes.UpDatePicker} style={props.requiredField ? CustomTypes.BORDER_RED : null}>
                    <DatePicker locale={locale} placeholderText={DataUtil.isPMDB() ? null : appDateFormat.toUpperCase()} dateFormat={appDateFormat} selected={selectedDate} name={props.name}
                        minDate={DataUtil.setMinMaxDate(props.minDate)} maxDate={DataUtil.setMinMaxDate(props.maxDate)} onChange={props.onChangeDate} ref={refDate}
                        popperPlacement={datePosition} popperModifiers={{ flip: { behavior: [datePosition] }, preventOverflow: { enabled: false }, hide: { enabled: false } }} />
                    <span><img alt="" className={classes.CalendarIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "calendarIcon")} onClick={() => refDate.current.setOpen(true)}></img></span>
                </div>
            </div>
        )
    } catch (error) {
        return (<div></div>)
    }
}

export const CustomDateTime = (props) => {
    const refDate = React.createRef();
    let appDateFormat = CustomForm.getDateFormatForApp(props.uiConfig);
    let format = `${appDateFormat} hh:mm:ss`;
    const CalendarIcon = () => {
        return <div><img alt="CalendarIcon" style={{ marginRight: "0px" }} className={classes.CalendarIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "calendarIcon")}></img></div>
    }

    const ClearIcon = () => {
        return <div><img alt="ClearIcon" className={classes.CalendarIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "DeleteButton")}></img></div>
    }
    return (
        <div className={classes.MetadataEntry}>
            <label className={classes.HightLightLb}>{props.label ? props.label : <FormattedMessage id={props.fMsgId} />}</label>
            <div className={classes.TimeDatePickerBox}>
                <DateTimePicker className={classes.TimeDateDiv}
                    yearPlaceholder="YYYY" monthPlaceholder="MM" dayPlaceholder="DD" hourPlaceholder="hh" minutePlaceholder="mm" secondPlaceholder="ss"
                    format={format} value={props.selectedDate} name={props.name} onChange={props.onChangeDate} ref={refDate}
                    calendarIcon={<CalendarIcon />} clearIcon={<ClearIcon />} calendarClassName={classes.TimeDateCalendar}
                    disableClock="true"
                />
            </div>
        </div>
    )
}


export const CustomDateTimeGroup = (props) => {
    try {
        const refFrom = React.createRef();
        const refTo = React.createRef();

        let selectedTo = DataUtil.isIsoString(props.selectedTo) ? moment(props.selectedTo).toDate() : props.selectedTo;
        let selectedFrom = DataUtil.isIsoString(props.selectedFrom) ? moment(props.selectedFrom).toDate() : props.selectedFrom;
        let appDateFormat = CustomForm.getDateFormatForApp(props.uiConfig);
        return (
            <div className={classes.DataFlexBox}>
                <label className={classes.DataHeading}>{props.label ? props.label : <FormattedMessage id={props.fMsgId} />}<CustomRequiredField {...props} /></label>
                <div className={classes.DataDatePicker}>
                    <div className={classes.DateTimeGroupBox}>
                        <span>{<FormattedMessage id="expertsearch.From" />}</span>
                        <DatePicker placeholderText={DataUtil.isPMDB() ? null : appDateFormat.toUpperCase()}
                            dateFormat={appDateFormat} ref={refFrom} selected={selectedFrom} onChange={props.onChangeFrom}
                            popperPlacement="top-start" popperModifiers={{ flip: { behavior: ["top-start"] }, preventOverflow: { enabled: false }, hide: { enabled: false } }} />
                        <input className={classes.DateTimeInput} type="time" name={props.nameIn} value={props.selectedIn} onChange={props.onChangeIn} step="2" />
                        <img alt="" className={classes.CalendarIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "calendarIcon")} onClick={() => refFrom.current.setOpen(true)}></img>
                    </div>
                    <div className={classes.DateTimeGroupBox}>
                        <span>{<FormattedMessage id="expertsearch.To" />}</span>
                        <DatePicker className={classes.DateTimeFirst} placeholderText={DataUtil.isPMDB() ? null : appDateFormat.toUpperCase()} dateFormat={appDateFormat} ref={refTo} selected={selectedTo} onChange={props.onChangeTo} popperPlacement="top-start" popperModifiers={{ flip: { behavior: ["top-start"] }, preventOverflow: { enabled: false }, hide: { enabled: false } }} />
                        <input className={classes.DateTimeInput} type="time" name={props.nameOut} value={props.selectedOut} onChange={props.onChangeOut} step="2" />
                        <img alt="" className={classes.CalendarIcons} src={CustomAppEventListener(CustomEvents.GET_ICON, "calendarIcon")} onClick={() => refTo.current.setOpen(true)} ></img>
                    </div>
                </div>
            </div>
        )
    } catch (error) {
        return (<div></div>)
    }
}

export const CustomTextArea = (props) => {
    try {
        return (
            <div className={classes.DataFlexBox}>
                <label className={classes.DataHeading}>{props.label ? props.label : <FormattedMessage id={props.fMsgId} />}<CustomRequiredField {...props} /></label>
                <textarea style={props.requiredField ? CustomTypes.BORDER_RED : null} className={classes.ResizableTextAreaDiv} name={props.name} value={props.value} onChange={props.onChange} rows={props.rows} id={props.id} />
            </div>)
    } catch (error) {
        return (<div></div>)
    }
}

export const CustomTextAreaWithIcon = (props) => {
    try {
        return (
            <div className={classes.DataFlexBox}>
                <label className={classes.DataHeading}>{<FormattedMessage id={props.fMsgId} />}</label>
                <div className={classes.TextAreaContainer}>
                    <textarea className={classes.ResizableTextAreaDiv} name={props.name} value={props.value} onChange={props.onChange} rows={props.rows} id={props.id} />
                    <img alt="" className={classes.InputIconBoxIcon} src={CustomAppEventListener(CustomEvents.GET_ICON, "descriptionIcon")}></img>
                </div>
            </div>)

    } catch (error) {
        return (<div></div>)
    }
}

export const CustomTimeGroup = (props) => {
    try {
        return (
            <div className={classes.DataFlexBox}>
                <label className={classes.DataHeading}>{<FormattedMessage id={props.fMsgId} />}</label>
                <div className={classes.DataTimePicker}>
                    <input style={{ paddingLeft: '8px' }} type="time" name={props.nameIn} value={props.selectedIn} onChange={props.onChangeIn} step="2" />
                    <input style={{ paddingLeft: '8px' }} type="time" name={props.nameOut} value={props.selectedOut} onChange={props.onChangeOut} step="2" />
                </div>
            </div>
        )
    } catch (error) {
        return (<div></div>)
    }
}

export const CustomCheckBoxList = (props) => {
    try {
        let data = props.data || [];
        let lg = DataUtil.getLanguage(props.lg);
        return (
            <div className={classes.CheckBoxListEntry}>
                {props.fMsgId ? (<label className={classes.DataHeading}>{<FormattedMessage id={props.fMsgId} />}<CustomRequiredField {...props} /></label>) : null}
                <div className={classes.CheckBoxList}>
                    {(((data) && (data.length) > 0)) ? (data.map((item, index) => { return (<div className={classes.CheckBoxListContent} key={index}><input style={{ marginLeft: '0px' }} name={DataUtil.getId(item)} type={props.type} value={item[lg]} onChange={props.onChange} checked={props.checkedData.find(el => el === DataUtil.getId(item))} /><span>{item[lg]}</span></div>) })) : null}
                </div>
            </div>
        )
    } catch (error) {
        return (<div></div>)
    }
}

export const CustomDropDownAndCheckBoxGroup = (props) => {
    try {
        let data = props.data;
        let lg = DataUtil.getLanguage(props.lg);
        let iconShow = CustomMedia.toggleArrowIcon(props.display);
        if (props.sorted) data = DataUtil.sortData(props.data, lg);

        return (<div>
            <div className={classes.DataListEntry}>
                <label className={classes.DataHeading}>{props.label ? props.label : <FormattedMessage id={props.fMsgId} />}</label>
                <div className={classes.DataListBox}>
                    <div className={classes.dropdown}>
                        <div className={classes.DataListRow} style={props.requiredField ? CustomTypes.BORDER_RED : null} >
                            <FormattedMessage id={props.fMsgId}>
                                {(Msg) => <input className={classes.dropInput} style={{ width: '100%' }} type="text" value={props.inputValue} onChange={props.onDdInputChange} onClick={props.onDdIputClick} placeholder={Msg} />}
                            </FormattedMessage> <span> <img alt="" className={classes.DataListIcons} src={iconShow} onClick={props.onDdInputClick}></img></span></div>
                        <div className={classes.dropdownContent} style={{ display: props.display }}>
                            {(((data) && (data.length) > 0)) ? (data.map((item, index) => (<input style={{ width: '100%' }} key={index} type={props.type} onClick={props.onDataClick} value={item[lg]} name={DataUtil.getId(item)} />))) : null}
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.DataFlexBox}>
                <label className={classes.DataHeading}></label>
                <input style={{ margin: "0 0.8em 0.8em 0" }} type="checkbox" name={props.name} value={props.value} onChange={props.onCheckBoxChange} checked={props.checked} /><span style={{ fontSize: "12.5px", color: "#5d5959" }}>{props.checkboxData ? props.checkboxData : ""}</span>
            </div></div>
        )
    } catch (error) {
        console.log("CustomDropDownAndCheckBoxGroup ERROR!");
        return (<div></div>)
    }
}

export const CustomAddDataBox = (props) => {
    return (<div className={classes.DataDialog}>
        <h2><FormattedMessage id={props.heading} /></h2>
        <FormattedMessage id={props.fMsgId}>
            {(Msg) => <input style={{ width: '100%', fontSize: '1.6em' }} className={classes.DataDialog__input} type={props.type} name={props.name} value={props.value} onChange={props.onChange} placeholder={Msg} />}
        </FormattedMessage>
        {/*<label className={classes.DataDialog__label} for={props.name} ><FormattedMessage id={props.fMsgId} /></label>*/}
        <div className={classes.DataDialog__button}>
            <CustomCenterButtonsBox style={{ width: '40%' }} fMsgIdSubmit={props.fMsgIdSubmit} fMsgIdCancel={props.fMsgIdCancel} onSubmitClick={props.onSubmitClick} onCancelClick={props.onCancelClick} />
        </div>
    </div>)
}

export const CustomAddSelect = (props) => {
    let lg = DataUtil.getLanguage(props.lg);
    return (
        <div>
            <div className={classes.CustomAddDd}>
                <select name={props.name} false="" type="dropdown" value={props.value} onChange={props.onChange} >
                    <FormattedMessage id="data.chooseTypeLb">
                        {(Msg) => <option value="">{Msg}</option>}
                    </FormattedMessage>
                    {props.data.map((item, index) => {
                        return (<option key={index} value={DataUtil.getId(item)}>{item[lg]}</option>)
                    })
                    }
                </select>
            </div>
        </div>
    )
}

export const CustomAddDataBoxWithDropDown = (props) => {
    let lg = DataUtil.getLanguage(props.lg);
    return (<div className={classes.AddDialogWithDd}>
        <h2 style={{ marginBottom: "0px" }}><FormattedMessage id={props.heading} /></h2>
        <FormattedMessage id={props.fMsgId}>
            {(Msg) => <input style={{ width: '100%', fontSize: '1.6em' }} className={classes.DataDialog__input} type="text" name={props.name} value={props.value} onChange={props.onChange} placeholder={Msg} />}
        </FormattedMessage>
        <CustomAddSelect lg={lg} fMsgId={props.ddfMsgId} name={props.ddname} value={props.ddvalue} onChange={props.onDdChange} data={props.data} />
        <div className={classes.DataDialog__button}>
            <CustomCenterButtonsBox style={{ width: '40%' }} fMsgIdSubmit={props.fMsgIdSubmit} fMsgIdCancel={props.fMsgIdCancel} onSubmitClick={props.onSubmitClick} onCancelClick={props.onCancelClick} />
        </div>
    </div>)
}

